(function initMundskaenkenMitIdCheckoutGuard() {
  if (window.__mundskaenkenMitIdCheckoutGuardActive) return;
  window.__mundskaenkenMitIdCheckoutGuardActive = true;

  const checkoutSelector = 'button[name="checkout"], #checkout, .cart__checkout-button';
  const retryDelayMs = 100;
  const maxAttempts = 30;
  const invocationLockMs = 1000;
  let verificationPending = false;

  function stopCheckout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function showUnavailableMessage(trigger) {
    const existingMessage = document.querySelector('[data-mundskaenken-mitid-error]');
    if (existingMessage) return;

    const message = document.createElement('p');
    message.dataset.mundskaenkenMitidError = '';
    message.setAttribute('role', 'alert');
    message.textContent = 'MitID-kontrollen kunne ikke indlæses. Genindlæs siden og prøv igen.';
    message.style.margin = '1rem 0 0';
    message.style.color = 'rgb(var(--color-foreground))';
    trigger.insertAdjacentElement('afterend', message);
  }

  function createMitIdEvent(trigger) {
    return {
      target: trigger,
      currentTarget: trigger,
      preventDefault() {},
      stopPropagation() {},
      stopImmediatePropagation() {},
    };
  }

  function openMitIdVerification(trigger, attempt = 0) {
    if (typeof window.mitIdShowForm === 'function') {
      try {
        window.mitIdShowForm(createMitIdEvent(trigger));
        // Release Dawn's dialog and keyboard trap before eID opens its own
        // dialog. eID remains the only authority for proceeding to checkout.
        const drawer = trigger.closest('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        window.setTimeout(() => {
          verificationPending = false;
        }, invocationLockMs);
      } catch {
        verificationPending = false;
        showUnavailableMessage(trigger);
      }
      return;
    }

    if (attempt >= maxAttempts) {
      verificationPending = false;
      showUnavailableMessage(trigger);
      return;
    }

    window.setTimeout(() => {
      openMitIdVerification(trigger, attempt + 1);
    }, retryDelayMs);
  }

  function guardCheckout(event) {
    const eventTarget = event.target;
    if (!(eventTarget instanceof Element)) return;

    const trigger = eventTarget.closest(checkoutSelector);
    if (!trigger) return;

    stopCheckout(event);
    if (verificationPending) return;

    verificationPending = true;
    openMitIdVerification(trigger);
  }

  window.addEventListener('click', guardCheckout, true);
})();
